<template>
  <div class="product-add">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="基础设置" name="basic"></el-tab-pane>
      <el-tab-pane label="价格政策" name="priceStage"></el-tab-pane>
      <el-tab-pane label="设备详情" name="content"></el-tab-pane>
      <el-tab-pane label="高级设置" name="buyset"></el-tab-pane>
    </el-tabs>
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="180px">
      <!--基础信息-->
      <Basic v-show="activeName == 'basic'" :scene="scene"></Basic>
      <!--价格政策-->
      <PriceStage v-show="activeName == 'priceStage'"></PriceStage>
      <!--设备详情-->
      <Content v-show="activeName == 'content'"></Content>
      <!--高级设置-->
      <Buyset v-show="activeName == 'buyset'"></Buyset>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">发布</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import Basic from './part/Basic.vue';
import PriceStage from './part/PriceStage.vue';
import Content from './part/Content.vue';
import Buyset from './part/Buyset.vue';
import Poster from './part/Poster.vue';
import {formatModel} from '@/utils/base.js';

export default {
  components: {
    /*基础信息*/
    Basic,
    /*价格政策*/
    PriceStage,
    /*设备详情*/
    Content,
    /*高级设置*/
    Buyset,
    /*设备海报*/
    Poster
  },
  data() {
    return {
      activeName: 'basic',
      /*是否正在加载*/
      loading: false,
      /*判断是编辑*/
      scene: 'add',
      /*form表单数据*/
      form: {
        model: {
          /*设备名称*/
          name: '',
          id: '',
          productNo: '',
          videoId: 0,
          posterId: 0,
          /*设备分类*/
          categoryId: 0,
          /*设备图片*/
          image: [],
          /*是否纯图*/
          isPicture: 0,
          contentImage: [],
          video: {
            fileId: 0,
            filePath: ''
          },
          poster: {
            fileId: 0,
            filePath: ''
          },
          /*设备卖点*/
          sellingPoint: '',
          /*规格类别,默认10单规格，20多规格*/
          specType: 10,
          /*库存计算方式,默认20付款减库存，10下单减库存*/
          deductStockType: 20,
          /*检查用户等级*/
          isAloneGrade: 0,
          sku: {
            stageType: 10,
          },
          /*多规格类别*/
          specMany: {
            /*多规格类别*/
            specAttr: [],
            /*多规格表格数据*/
            specList: []
          },
          /*设备详情内容*/
          content: '',
          /*运费模板ID*/
          deliveryId: '',
          /*设备状态*/
          productStatus: 10,
          /*初始销量*/
          salesInitial: 0,
          /*设备排序，默认100*/
          productSort: 100,
          /*是否开启积分赠送,默认1为开启，0为关闭*/
          isPointsGift: 1,
          /*是否允许使用积分抵扣,默认1为允许，0为不允许*/
          isPointsDiscount: 1,
          /*最大积分抵扣数量*/
          maxPointsDiscount: 0,
          /*限购会员*/
          gradeIds: [],
          /*是否虚拟设备*/
          isVirtual: 1,
          /*限购数量*/
          limitNum: 0,
          /*虚拟设备发货方式*/
          virtualAuto: 0,
          /*虚拟设备发货内容*/
          virtualContent: '',
          /*关联表单*/
          tableId: '',
          audit_setting: {}
        },
        /*设备分类*/
        category: [],
        /*运费模板*/
        delivery: [],
        /*会员等级*/
        gradeList: [],
        /*规格数据*/
        specData: null,
        /*是否锁住*/
        isSpecLocked: false,
      }
    };
  },
  provide: function () {
    return {
      form: this.form
    };
  },
  created() {
    /*获取基础数据*/
    this.getBaseData();
  },
  methods: {
    /*获取基础数据*/
    getBaseData: function () {
      let self = this;
      PorductApi.getBaseData({}, true)
        .then(res => {
          self.loading = false;
          Object.assign(self.form, res.data);
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*转JSON字符串*/
    convertJson(list) {
      let obj = {};
      list.forEach(item => {
        obj[item.id] = item.productEquity;
      });
      return JSON.stringify(obj);
    },

    /*提交*/
    onSubmit: function () {
      let self = this;
      let params = self.form.model;
      params.userType = 'USER';
      params.productId = 'DC-WB';
      params.productName = '无人值守电子秤';
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          if (params.gradeIds.length > 0) {
            params.gradeIds = params.gradeIds.join(',');
          } else {
            params.gradeIds = '';
          }
          PorductApi.addProduct(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '添加成功',
                type: 'success'
              });
              self.$router.push('/product/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/add.vue